import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signOut, type User } from 'firebase/auth';
import { auth } from '../config/firebase';

interface AuthContextType {
  user: User | null;
  loading: boolean;
  logout: () => Promise<void>;
  isSuperAdmin: boolean;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
  logout: async () => {},
  isSuperAdmin: false,
});

// Correos autorizados como SuperAdmin. undermixpro@gmail.com queda temporalmente como
// respaldo mientras se confirma que el login con Google Workspace (@undermix.cl) funciona
// bien en producción; sacarlo de aquí una vez confirmado. También hay que actualizar
// isSuperAdmin() en firestore.rules — esta lista solo controla la puerta de la interfaz,
// la que de verdad protege los datos es la de las reglas.
export const SUPERADMIN_EMAILS = ['oliver@undermix.cl', 'undermixpro@gmail.com'];

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = async () => {
    await signOut(auth);
  };

  const isSuperAdmin = SUPERADMIN_EMAILS.includes(user?.email?.toLowerCase() || '');

  return (
    <AuthContext.Provider value={{ user, loading, logout, isSuperAdmin }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
